import { useNavigate } from 'react-router-dom';

export default function AnalyzeMap() {
  const MapPDF = "/stageAssets/stage0/MapOfDevelopment.pdf";

  const navigate = useNavigate();

  const handleExperienceClick = () => {
    navigate("/Stage0");
  };

  return (
    <div
      style={{
        maxWidth: "1100px",
        margin: "0 auto",
        padding: "60px 30px",
        color: "white",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        Telos: Analyze the Maps
      </h1>

      <div
        style={{
          textAlign: "center",
          marginBottom: "40px",
        }}
      >
        <button
          onClick={handleExperienceClick}
          style={{
            padding: "14px 30px",
            fontSize: "18px",
            cursor: "pointer",
            borderRadius: "8px",
            border: "none",
          }}
        >
          Have An Experience
        </button>
      </div>

      <div
        style={{
          textAlign: "left",
          lineHeight: "1.8",
          fontSize: "18px",
          marginBottom: "40px",
        }}
      >
        <p>
            Life does not come with a manual, but it does come wiht a map!
        </p>

        <p>
          While "Experience" is one way of knowing, "Analyization" is just as valid. 
          Throughout history and across cultures, the "Map of Life" has been 
          charted at various depths and scopes...and perhaps most shocking of all,
          it is also a map of you! 
        </p>
        <p> 
          Though the names differ, the pattern repeats: human life unfolds
          through recognizable stages of development. From survival to identity,
          from ego to meaning, from separation to integration, each map points
          to the same territory.
        </p>

        <p>
          The PDF below is a collection of developmental maps by generally
          well-known philosophers, psychologists, mystics, and scientists.
          Even the world’s three major religions—Christianity, Islam, and
          Buddhism—follow the same core structure. The world’s oldest religion,
          Hinduism, includes a similar map found in the Chakra System.
        </p>
      </div>

      <iframe
        src={MapPDF}
        width="100%"
        height="900px"
        title="Map of Development PDF"
        style={{
          border: "none",
          borderRadius: "12px",
        }}
      />
    </div>
  );
}